module.exports = __webpack_public_path__ + "static/loading-115170f0af0b5d3b82986daf16cd7c1c.gif";